export default __webpack_public_path__ + "static/Gilroy-ExtraBold-a0186386a547e698658b59e9233ede23.woff2";